import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiStar, FiArrowLeft, FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import PortalHeader from '../../components/Portal/PortalHeader';
import ProductCard from '../../components/Portal/ProductCard';
import ProductDetailModal from '../../components/Portal/ProductDetailModal';
import LoginModal from '../../components/Portal/LoginModal';
import { useNewProducts } from '../../hooks/portal/usePortal';
import { useAuth } from '../../contexts/AuthContext';
import './NuevosProductos.scss';

const NuevosProductos = () => {
  const navigate = useNavigate();
  // Catálogo completo: el tope de 50 dejaba fuera casi toda la categoría Betel
  const { products, loading } = useNewProducts(500);
  const { isAuthenticated } = useAuth();
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [page, setPage] = useState(1);

  // Paginación en cliente (12 por página = 3 filas de 4 en escritorio)
  const PER_PAGE = 12;
  const totalPages = Math.max(1, Math.ceil((products?.length || 0) / PER_PAGE));
  const paginated = (products || []).slice((page - 1) * PER_PAGE, page * PER_PAGE);
  const changePage = (p) => {
    if (p < 1 || p > totalPages || p === page) return;
    setPage(p);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleProductClick = (product) => {
    if (!isAuthenticated) {
      setShowLoginModal(true);
      return;
    }
    setSelectedProduct(product);
  };

  const handleCloseModal = () => {
    setSelectedProduct(null);
  };

  const handleLoginRequired = () => {
    setShowLoginModal(true);
  };

  if (loading) {
    return (
      <div className="portal-page">
        <PortalHeader />
        <div className="portal-page__loading">Cargando nuevos productos...</div>
      </div>
    );
  }

  return (
    <div className="portal-page nuevos-productos">
      <PortalHeader />

      <div className="portal-page__container">
        <button
          onClick={() => navigate('/portal')}
          className="back-button"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            background: 'transparent',
            border: 'none',
            color: '#7b2c7f',
            fontSize: '1rem',
            fontWeight: '600',
            cursor: 'pointer',
            padding: '0.5rem 0',
            marginBottom: '1rem',
            transition: 'color 0.2s ease'
          }}
          onMouseEnter={(e) => e.currentTarget.style.color = '#5d1f5f'}
          onMouseLeave={(e) => e.currentTarget.style.color = '#7b2c7f'}
        >
          <FiArrowLeft size={20} /> Volver al Portal
        </button>
        <div className="nuevos-productos__header">
          <h1 className="portal-page__title">
            <FiStar /> Nuevos Productos
          </h1>
          <p className="subtitle">
            Descubre los productos más recientes en nuestro catálogo
          </p>
        </div>

        {products && products.length > 0 ? (
          <>
            <div className="productos-grid">
              {paginated.map((product) => (
                <ProductCard
                  key={product.id}
                  product={product}
                  onClick={() => handleProductClick(product)}
                  onLoginRequired={handleLoginRequired}
                />
              ))}
            </div>

            {totalPages > 1 && (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '16px', margin: '0 0 2rem', flexWrap: 'wrap' }}>
                <button
                  type="button"
                  onClick={() => changePage(page - 1)}
                  disabled={page <= 1}
                  title="Página anterior"
                  aria-label="Página anterior"
                  style={{
                    width: 40, height: 40, borderRadius: '50%', border: '1.5px solid #7b2c7f',
                    background: '#fff', color: '#7b2c7f', display: 'inline-flex', alignItems: 'center',
                    justifyContent: 'center', cursor: page <= 1 ? 'not-allowed' : 'pointer', opacity: page <= 1 ? 0.4 : 1
                  }}
                >
                  <FiChevronLeft size={20} />
                </button>
                <span style={{ fontSize: '0.95rem', color: '#6b7280', fontWeight: 600 }}>
                  Página {page} de {totalPages} · {products.length} productos
                </span>
                <button
                  type="button"
                  onClick={() => changePage(page + 1)}
                  disabled={page >= totalPages}
                  title="Página siguiente"
                  aria-label="Página siguiente"
                  style={{
                    width: 40, height: 40, borderRadius: '50%', border: '1.5px solid #7b2c7f',
                    background: '#fff', color: '#7b2c7f', display: 'inline-flex', alignItems: 'center',
                    justifyContent: 'center', cursor: page >= totalPages ? 'not-allowed' : 'pointer', opacity: page >= totalPages ? 0.4 : 1
                  }}
                >
                  <FiChevronRight size={20} />
                </button>
              </div>
            )}
          </>
        ) : (
          <div className="empty-state">
            <div className="empty-state__icon">
              <FiStar />
            </div>
            <h2>No hay nuevos productos disponibles</h2>
            <p>Revisa más tarde para ver las novedades</p>
          </div>
        )}
      </div>

      {selectedProduct && (
        <ProductDetailModal
          product={selectedProduct}
          onClose={handleCloseModal}
          onLoginRequired={handleLoginRequired}
        />
      )}

      <LoginModal
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
      />
    </div>
  );
};

export default NuevosProductos;
